import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";
import { NeuDropdown } from "../../components/data/NeuDropdown";
import { Field, Section } from "./ItemFormParts";
import { localName } from "../../lib/localName";

const STOCK = [["min_stock", "minStock"], ["max_stock", "maxStock"], ["reorder_point", "reorderPoint"]];

// معلومات المخزون (للمواد المخزنية) + مركز التكلفة الافتراضي + الوصف.
export const ItemSectionStock = ({ form, setForm, centers }) => {
  const { t, i18n } = useTranslation();
  const ar = i18n.language === "ar";
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <>
      {form.item_type === "inventory" ? (
        <Section testid="item-section-stock" cols={3} title={t("purchases.items.stockInfo")}>
          {STOCK.map(([key, label]) => (
            <Field key={key} label={t(`purchases.items.${label}`)}>
              <NeuInput data-testid={`item-${key}`} dir="ltr" value={form[key] ?? ""} onChange={set(key)} />
            </Field>
          ))}
        </Section>
      ) : null}
      <Section testid="item-section-extra">
        <Field label={t("purchases.items.costCenter")}>
          <NeuDropdown testid="item-cost-center" value={form.default_cost_center_id}
                       placeholder={t("purchases.items.pickCostCenter")}
                       onChange={(value) => setForm({ ...form, default_cost_center_id: value })}
                       options={centers.map((row) => ({ value: row.id,
                         label: `${row.code} — ${localName(row)}` }))} />
        </Field>
        <Field label={t("purchases.items.description")} className="sm:col-span-2">
          <textarea data-testid="item-description" rows={3} value={form.description || ""} onChange={set("description")}
                    className="min-h-[6rem] w-full resize-y rounded-2xl border border-border/60 bg-background px-4 py-3 text-sm shadow-neu-in outline-none focus:ring-2 focus:ring-ring" />
        </Field>
      </Section>
    </>
  );
};
